import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { useResponsive } from '#core/SdgQuiz/utils';

type SdgIndicatorProps = {
  label: string;
  value: string;
  color: string;
};

const SdgIndicator = ({ label, value, color }: SdgIndicatorProps) => {
  const isMobileScreen = useResponsive();

  return (
    <Flex mb={6} flexWrap="wrap" fontSize={isMobileScreen ? 'sm' : 'md'}>
      <Text color="#838383" mr={2}>
        {label}
      </Text>
      <Text fontWeight="bold" color={color}>
        {value}
      </Text>
    </Flex>
  );
};

export default SdgIndicator;
